export const HfPrefix = "high-frequency"
export const robotPrefix = "robot"